document.addEventListener('DOMContentLoaded', function () {

    /*** ---------------- KV TAG FUNCTIONS ---------------- ***/
    async function updateCartKVTag(sku, tagValue) {
        try {
            // Fetch current cart state
            const cartResponse = await fetch('/cart.js');
            const cart = await cartResponse.json();

            // Exact-match check for the KV product SKU
            const itemExists = cart.items.some(i =>
                (i.sku || '').trim().toLowerCase() === (sku || '').trim().toLowerCase()
            );

            // Update cart-level 'tag' attribute
            await updateCartAttribute('tag', itemExists ? tagValue : '');

            // Check for any HRL product (broad includes-check)
            const hasHRLProduct = cart.items.some(i =>
                (i.sku || '').toLowerCase().includes('hrl')
            );

            // window.kvAllowedEmails is set in cart-drawer.liquid (a .liquid file where
            // Liquid IS evaluated). Using it here avoids the Liquid-in-static-JS problem
            // where "{{ settings.allowed_emails }}" was output as a literal string.
            const allowedEmails = (window.kvAllowedEmails || [])
                .map(e => (e || '').trim().toLowerCase());

            // window.customerEmail is already set by cart-drawer.liquid line:
            //   window.customerEmail = {{ customer.email | json }};
            const customerEmail = (window.customerEmail || '').trim().toLowerCase();

            // Update 'order_source' attribute
            await updateCartAttribute(
                'order_source',
                hasHRLProduct && allowedEmails.includes(customerEmail) ? 'HRL' : ''
            );

            // FIX 1 — Use .value (not .textContent) on <input> elements.
            // FIX 2 — Use querySelectorAll so every cart-item row is updated,
            //          not just the first one (there is one .kvattribute per item).
            document.querySelectorAll('.kvattribute').forEach(input => {
                input.value = itemExists ? tagValue : '';
            });

            console.log("KV tag updated:", itemExists ? tagValue : "removed");

        } catch (err) {
            console.error("Error updating KV tag:", err);
        }
    }

    async function updateCartAttribute(attr, value) {
        try {
            const res = await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ attributes: { [attr]: value } })
            });

            return await res.json();

        } catch (e) {
            console.error(e);
        }
    }

    /*** ---------------- CART OPEN EVENT ---------------- ***/

    // FIX 3 — Removed the duplicate setTimeout cartOpen dispatch that was here.
    //
    // Reason: two other places already cover this:
    //   a) cart-drawer.liquid already fires cartOpen after 1 s on DOMContentLoaded.
    //   b) cart-drawer.js open() fires cartOpen every time the drawer actually opens.
    //
    // Having a third dispatch here caused updateCartKVTag (and therefore three
    // POST requests to /cart/update.js) to fire in rapid succession on every
    // page load + cart open, with no benefit.

    // CART DRAWER OPEN EVENT — runs updateCartKVTag each time the drawer opens
    // (including after renderContents() re-renders the drawer on product add).
    document.addEventListener('cartOpen', async function () {
        await updateCartKVTag('all-hrl-kv', 'kv-meal-kit');
    });

    // INITIAL KV TAG UPDATE ON PAGE LOAD
    // Handles the case where the cart already has items when the page loads.
    updateCartKVTag('all-hrl-kv', 'kv-meal-kit');

});
